import { domainReputationMapper } from '../mappers/domain-reputation-mapper';
import { emailReputationMapper } from '../mappers/email-reputation-mapper';
import { urlReputationMapper } from '../mappers/url-reputation-mapper';
import { apiClient } from '../shared/api-client';
import { logError } from '../shared/error-logger';

const reputationRepository = {
    async checkDomain(domain) {
        try {
            const data = await apiClient.get({
                url: `reputation/domain`,
                params: {domain},
                isCheckAccessToken: true
            });

            return domainReputationMapper.toDomain(data);
        } catch (error) {
            logError(error);

            throw error;
        }
    },
    async checkUrl(url) {
        try {
            const data = await apiClient.get({
                url: `reputation/url`,
                params: {url},
                isCheckAccessToken: true
            });

            return urlReputationMapper.toDomain(data);
        } catch (error) {
            logError(error);

            throw error;
        }
    },
    async checkEmail(email) {
        try {
            const data = await apiClient.get({
                url: `reputation/email`,
                params: {email},
                isCheckAccessToken: true
            });

            return emailReputationMapper.toDomain(data);
        } catch (error) {
            logError(error);

            throw error;
        }
    }
};
  
export {
    reputationRepository
};
